import HTTP from './http'
import { createHttp } from './helpers'
import { EDOCSIGNPROVIDER_URL } from '../utils/constants'
import { API_HEADER_CONTENT_TYPE as HEADER } from './constants'
import { IHTTPVerbsData } from './interface'

export const eDocSignProviderEContractCreatePost = ({ data, id }: IHTTPVerbsData) =>
  createHttp(EDOCSIGNPROVIDER_URL).post(`/api/methods/template-fill/${id}`, data)

export const eDocSignProviderEContractGet = ({ id }: IHTTPVerbsData) =>
  createHttp(EDOCSIGNPROVIDER_URL).get(`/api/methods/get/contract/${id}`, {
    headers: {
      ...HEADER.eDocSignProviderApiToken,
      ...HEADER.json
    }
  })

export const contractSendUrlPost = ({ data, id, token }: IHTTPVerbsData) =>
  HTTP.onboarding.post(`/v1/entity/${id}/edoc-sign-provider`, JSON.stringify(data), {
    headers: {
      ...HEADER.auth.bearer(token),
      ...HEADER.json
    }
  })
